import React from 'react';

import { Button } from '@components/Button';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { MetaHelper } from '@utils/pages';
import { Helmet } from 'react-helmet';
import { Link, useLocation } from 'react-router-dom';

const useStyles = makeMuiStyles((theme, common) => ({
  layout: {
    ...common.flexColumn,
    height: '100vh',
  },
  navigation: {
    ...common.textWhite,
    ...common.flexInline,
    backgroundColor: theme.palette.primary.main,
    padding: '0.5rem',
  },
  children: {
    flexShrink: 1,
    overflow: 'auto',
  },
}));

export interface DevLayoutProps {}

export const DevLayout: React.FC<React.PropsWithChildren<{}>> = (props) => {
  const { children } = props;

  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const pages = MetaHelper.instance!.withPrefix('/dev').filter((p) => !p.name.startsWith('Test'));
  const location = useLocation();

  return (
    <div className={classes.layout}>
      <Helmet>
        <title>{location.pathname}</title>
      </Helmet>

      <div className={classes.navigation}>
        <Link to="/">
          <Button color="primary" text="Dashboard" />
        </Link>
        <Link to="/admin">
          <Button color="primary" text="Admin" />
        </Link>
        {pages.map((p) => (
          <Link to={p.url} key={p.url}>
            <Button color="primary" key={p.url} text={p.name} />
          </Link>
        ))}
      </div>
      <div className={classes.children}>{children}</div>
    </div>
  );
};
